import React, { useState, useEffect } from "react";
import { Dialog, Button } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { useTranslation } from "react-i18next";

const ViewReadMoreModal = ({ readMoreHtml }) => {
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <div
        style={{
          display: "flex",
          justifyContent: "end",
          height: "1px",
        }}
      >
        <InfoIcon
          onClick={() => setVisible(true)}
          sx={{
            position: "relative",
            bottom: "40px",
            right: "20px",
            cursor: "pointer",
            fontSize: "24px",
            color: "#439bd9",
          }}
        />
      </div>
      <Dialog
        open={visible}
        onClose={() => setVisible(false)}
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          className="read-more-item"
          style={{ width: "min(95vw, 950px)" }}
          dangerouslySetInnerHTML={{
            __html: readMoreHtml,
          }}
        />
        <div className="read-more-item-close">
          <Button onClick={() => setVisible(false)}>{t("sluiten")}</Button>
        </div>
      </Dialog>
    </React.Fragment>
  );
};

export default ViewReadMoreModal;
